import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient"; // Assuming this is where you have the Supabase client
import GoalTracker from "../components/GoalTracker/GoalTracker";
import ChatCtaCard from "../components/ChatCtaCard/ChatCtaCard";
import DailyReflection from "../components/DailyReflection/DailyReflection";
import HeaderSection from "../components/HeaderSection/HeaderSection";
import NavBar from "../components/NavBar/NavBar";
import WelcomeModal from "../components/WelcomeModal/WelcomeModal";
import TrainMindCard from "../components/TrainMindCard/TrainMindCard";

export default function Dashboard() {
  const [journalEntries, setJournalEntries] = useState([]);
  const [isSideNav, setIsSideNav] = useState(true);
  const [userId, setUserId] = useState(null); // State for the user ID
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    // Fetch user ID from Supabase session
    const fetchUserId = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        setUserId(session.user.id); // Set userId to the state
      }
    };

    fetchUserId();
  }, []);

  // Show welcome modal once after onboarding completion
  useEffect(() => {
    const flag = localStorage.getItem('just_onboarded');
    if (flag === '1') {
      setShowWelcome(true);
      localStorage.removeItem('just_onboarded');
    }
  }, []);

  const addJournalEntry = (entry) => {
    setJournalEntries([...journalEntries, entry]);
  };

  return (
    <>
      <NavBar />
      <main className="web-view">
        <WelcomeModal
          open={showWelcome}
          onClose={() => setShowWelcome(false)}
        />
        <div className="dashboard">
          {/* Add DayTracker component at the top and make sure it spans the width */}
          <div className="date-section">
            <HeaderSection />
          </div>

          <div className="reflection-section">
            <DailyReflection onAddEntry={addJournalEntry} />
          </div>
          <div className="trainmind-section">
            <TrainMindCard />
          </div>
          <div className="dashboard-section">
            <GoalTracker />
          </div>
          {/* Simplified AI Trainer widget CTA */}
          <ChatCtaCard />
        </div>
      </main>
    </>
  );
}
